import { observer } from "mobx-react";
import { dialogStore } from "./stores/DialogStore";
import Dialog from "./Dialog";

const Dialogs = observer(() => {
  return (
    <>
      {dialogStore.dialogs.map((dialog) => (
        <Dialog key={dialog.id} {...dialog} />
      ))}
    </>
  );
});

export default Dialogs;
